import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { servicePackages } from "../content/services";

const colorMap = {
  blue: {
    bg: "bg-blue-50",
    icon: "bg-blue-100 text-blue-700",
    badge: "bg-blue-100 text-blue-700",
    hover: "hover:border-blue-300",
  },
  indigo: {
    bg: "bg-indigo-50",
    icon: "bg-indigo-100 text-indigo-700",
    badge: "bg-indigo-100 text-indigo-700",
    hover: "hover:border-indigo-300",
  },
  cyan: {
    bg: "bg-cyan-50",
    icon: "bg-cyan-100 text-cyan-700",
    badge: "bg-cyan-100 text-cyan-700",
    hover: "hover:border-cyan-300",
  },
  red: {
    bg: "bg-red-50",
    icon: "bg-red-100 text-red-700",
    badge: "bg-red-100 text-red-700",
    hover: "hover:border-red-300",
  },
  violet: {
    bg: "bg-violet-50",
    icon: "bg-violet-100 text-violet-700",
    badge: "bg-violet-100 text-violet-700",
    hover: "hover:border-violet-300",
  },
  emerald: {
    bg: "bg-emerald-50",
    icon: "bg-emerald-100 text-emerald-700",
    badge: "bg-emerald-100 text-emerald-700",
    hover: "hover:border-emerald-300",
  },
};

const serviceIcons = ["WD", "APP", "OPS", "SEC", "AI", "DB"];

export default function Services() {
  return (
    <section id="services" className="py-28 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
            What We Offer
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mt-2 mb-4">
            Our Services
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto text-lg leading-relaxed">
            End-to-end technology services designed to grow your business and solve real-world problems with thoughtful design and execution.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {servicePackages.map((service, index) => {
            const colors = colorMap[service.color];

            return (
              <div
                key={service.name}
                style={{ animationDelay: `${index * 120}ms` }}
                className={`animate-fade-in opacity-0 rounded-[1.75rem] border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${colors.hover}`}
              >
                <div className={`mb-5 flex h-14 w-14 items-center justify-center rounded-3xl text-sm font-bold tracking-wide shadow-sm ${colors.icon}`}>
                  {serviceIcons[index]}
                </div>

                <h3 className="mb-3 text-xl font-bold text-slate-900">{service.shortTitle}</h3>
                <p className="mb-6 text-sm leading-relaxed text-slate-500">{service.description}</p>

                <div className={`mb-5 rounded-2xl px-4 py-3 ${colors.bg}`}>
                  <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Starting Price</p>
                  <p className="mt-1 text-lg font-bold text-slate-900">{service.price}</p>
                  <p className="mt-1 text-sm text-slate-600">{service.deliveryTimeline}</p>
                </div>

                <div className="flex flex-wrap gap-2">
                  {service.features.map((feature) => (
                    <span
                      key={feature}
                      className={`rounded-full px-3 py-2 text-xs font-semibold shadow-sm ${colors.badge}`}
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-5 rounded-[2rem] border border-slate-200 bg-white px-6 py-6 text-center shadow-sm md:flex-row md:text-left">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-blue-600">
              Pricing & Refunds
            </p>
            <h3 className="mt-2 text-2xl font-bold text-slate-900">
              Review AED service pricing before you request checkout approval.
            </h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-500">
              See service descriptions, package structure, delivery timelines, tax notes, and refund eligibility in one dedicated page.
            </p>
          </div>

          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 rounded-3xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-1 hover:bg-slate-800"
          >
            View Pricing
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
